<!--
    BD Generic Form Dialog — Wave 4.4
    Dynamischer Fallback-Dialog. Liest uiComponentConfig (JSON) und rendert
    Felder oder faellt auf eine einzige Begruendungs-Textarea zurueck.
    Bei Bestaetigung wird decideManualContractDecision mit action='CONTINUE' aufgerufen.
    @ticket TM-1000001782
-->
@if (initialized) {
    <p-dialog
            [(visible)]="visible"
            [modal]="true"
            [closable]="true"
            [closeOnEscape]="true"
            [dismissableMask]="false"
            [style]="{width: '36rem'}"
            [header]="dialogTitle"
            (visibleChange)="onVisibleChange($event)">

        <div class="flex flex-column gap-3 p-2">

            <!-- Mahnungs-Info -->
            <div class="surface-card border-round p-3 flex flex-column gap-2">
                <div class="flex align-items-center gap-2">
                    <i class="fa-regular fa-user text-primary"></i>
                    <span class="font-semibold">Kunde:</span>
                    <span>{{ customerName }}</span>
                </div>
                <div class="flex align-items-center gap-2">
                    <i class="fa-regular fa-file-lines text-primary"></i>
                    <span class="font-semibold">Mahn-Typ:</span>
                    <span>{{ dunningTypeName }}</span>
                </div>
                <div class="flex align-items-center gap-2">
                    <i class="fa-regular fa-layer-group text-primary"></i>
                    <span class="font-semibold">Aktive Stufe:</span>
                    <span>{{ activeLevelLabel }}</span>
                </div>
            </div>

            <!-- Hinweis im Fallback-Modus -->
            @if (isFallback) {
                <p-message
                        severity="info"
                        text="Keine spezifische Konfiguration vorhanden. Bitte eine Begründung angeben."
                        styleClass="w-full">
                </p-message>
            }

            <!-- Dynamische Felder -->
            <div class="flex flex-column gap-3">
                @for (state of fieldStates; track trackByName($index, state)) {
                    <div class="flex flex-column gap-1">
                        <label class="block text-sm font-medium">
                            {{ state.config.label }}
                            @if (state.config.required) {
                                <span class="text-red-500">*</span>
                            }
                        </label>

                        @switch (state.config.type) {
                            @case ('textarea') {
                                <textarea
                                        pTextarea
                                        rows="3"
                                        [(ngModel)]="state.value"
                                        [placeholder]="state.config.placeholder ?? ''"
                                        class="w-full">
                                </textarea>
                            }
                            @case ('date') {
                                <input type="date"
                                       pInputText
                                       [(ngModel)]="state.value"
                                       [placeholder]="state.config.placeholder ?? ''"
                                       class="w-full">
                            }
                            @case ('number') {
                                <input type="number"
                                       pInputText
                                       [(ngModel)]="state.value"
                                       [placeholder]="state.config.placeholder ?? ''"
                                       class="w-full">
                            }
                            @default {
                                <input type="text"
                                       pInputText
                                       [(ngModel)]="state.value"
                                       [placeholder]="state.config.placeholder ?? ''"
                                       class="w-full">
                            }
                        }
                    </div>
                }
            </div>

            <!-- Error -->
            @if (errorMessage) {
                <p-message
                        severity="error"
                        [text]="errorMessage"
                        styleClass="w-full">
                </p-message>
            }
        </div>

        <!-- Footer -->
        <ng-template #footer>
            <div class="flex justify-content-end gap-2 w-full">
                <p-button
                        label="Abbrechen"
                        severity="secondary"
                        [disabled]="submitting"
                        (onClick)="onCancel()">
                </p-button>
                <p-button
                        label="Bestätigen"
                        icon="fa-regular fa-check"
                        [loading]="submitting"
                        (onClick)="confirm()">
                </p-button>
            </div>
        </ng-template>
    </p-dialog>
}
